export const DAILY_EVENT_COUNT = 6;
// Public game numbers continue upward; only the source event-set index cycles.
export const CONTENT_RESET_AFTER_GAME_DAY = 447;
// The verified daily library currently contains complete sets 1 through 409.
export const CONTENT_CYCLE_LENGTH = 409;

export const getDailyContentDay = (gameDay) => {
  if (!Number.isFinite(gameDay)) return null;
  if (gameDay <= CONTENT_RESET_AFTER_GAME_DAY) return gameDay;

  return ((gameDay - CONTENT_RESET_AFTER_GAME_DAY - 1) % CONTENT_CYCLE_LENGTH) + 1;
};

export const getDailyEventsForDay = (events, day) => {
  if (!Array.isArray(events) || !Number.isFinite(day)) return [];
  return events.filter((event) => event?.day === day);
};

export const getDailyAvailability = ({ events, day, loadState }) => {
  if (loadState === "error") return "error";
  if (loadState !== "ready" || !Number.isFinite(day)) return "loading";

  const contentDay = getDailyContentDay(day);
  return getDailyEventsForDay(events, contentDay).length === DAILY_EVENT_COUNT
    ? "ready"
    : "unavailable";
};
